import { IField } from '@eventr/common'
import { DateTimePicker } from '@eventr/common-storybook'
import { useState } from 'react'
import i18n from '../../../i18n/i18next'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { useEditSectionContext } from '../editSectionProvider'

interface ITimeEditFieldProps {
    field: IField
    _id?: string
}

export const TimeEditField = ({ field, _id }: ITimeEditFieldProps) => {
    const { getValue } = useEditSectionContext()
    const { updateValues, deleteSetValue } = useEditSectionContext()
    const { getLanguageISO639Code } = useLanguageContext()

    function getInitValue() {
        const initFieldValue = getValue(field, _id)
        if (
            typeof initFieldValue !== 'string' &&
            initFieldValue !== null &&
            typeof initFieldValue !== 'number'
        ) {
            return JSON.stringify(initFieldValue)
        } else {
            return initFieldValue ?? ''
        }
    }

    const [state, setState] = useState<string>(getInitValue())

    return (
        <DateTimePicker
            eventrDateString={state}
            fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
            onChange={(date) => {
                if (date !== undefined) {
                    setState(date)
                    updateValues({
                        value: date,
                        field: field,
                        _id: _id,
                    })
                } else {
                    /// Should deal with clear function.
                    setState(date)
                    deleteSetValue({ value: date, field: field, _id: _id })
                }
            }}
            locale={getLanguageISO639Code()}
            saveText={i18n.t('general.done')}
            clearText={i18n.t('general.clear')}
            minuteText={i18n.t('general.minute')}
            hourText={i18n.t('general.hour')}
            selectDateText={i18n.t('edit-itinerary.fields.select-date')}
            selectTimeText={i18n.t('edit-itinerary.fields.select-time')}
        />
    )
}
